import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, ValidationErrors } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

// models
import { AssortmentType } from '../../../product/models/models';
import { ILimitation } from '../../models/limitation';
import { MixpanelEvents } from '../../models/mixpanelEvents';
import { LimitationsCodeNames } from '../../models/limitationsCodeNames';

// services
import { MixpanelService } from '../../services/mixpanel.service';
import { ProductsService } from '../../services/products.service';
import { SessionService } from '../../services/session.service';
import { SnackBarService } from '../../services/snack-bar.service';

@Component({
    selector: 'app-connect-type-modal',
    templateUrl: './connect-type-modal.component.html',
    styleUrls: ['./connect-type-modal.component.scss'],
    standalone: false
})
export class ConnectTypeModalComponent implements OnInit, OnDestroy {

	public assortmentTypes: typeof AssortmentType = AssortmentType;
	public loader: boolean = false;
	public productsLimit: number = 0;
	public typeFormControl: FormControl<AssortmentType>;

	private _subscriptions: Array<Subscription> = [];

	private static typeValidator = (control: FormControl<AssortmentType>): ValidationErrors | null =>
		control.value !== AssortmentType.NONE ? null : { isValid: true };

	constructor(
		private router: Router,
		private dialogRef: MatDialogRef<ConnectTypeModalComponent>,
		private mixPanelService: MixpanelService,
		private productsService: ProductsService,
		private sessionService: SessionService,
		private snackBarService: SnackBarService
	) {}

	public ngOnInit(): void {
		this.typeFormControl = new FormControl<AssortmentType>(AssortmentType.NONE, ConnectTypeModalComponent.typeValidator);
		this._subscriptions.push(
			this.sessionService.limitations[LimitationsCodeNames.Products].subscribe((l: ILimitation) => {
				this.productsLimit = l.limit ?? 0;
			})
		);
	}

	public apply(): void {
		this.loader = true;
		if (this.typeFormControl.value === AssortmentType.TEST) {
			this.productsService.loadTestAssortment(true).subscribe({
				error: () => {
					this.loader = false;
					this.snackBarService.setErrorNotification();
				},
				complete: () => {
					this.productsService.assortmentType = AssortmentType.TEST;
					this.router.navigate(this.sessionService.getLink(['home'])).then();
					this.dialogRef.close();
				}
			});
		} else {
			this.mixPanelService.trackPage(MixpanelEvents.DemoAssortmentCreate, { type: 'OWN' });
			this.router.navigate(this.sessionService.getLink(['product', 'assortment-upload'])).then();
			this.dialogRef.close();
		}
	}

	public setActiveType(type: AssortmentType): void {
		this.typeFormControl.setValue(type);
	}

	public ngOnDestroy(): void {
		this._subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
	}
}
